import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

// --- Environment ---
import { environment } from '@environments/environment';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const { apiVersion, baseUrl } = environment;

		const apiReq = request.clone({
			url: `${baseUrl}/api/v${apiVersion}/${request.url}`,
		});

		return next.handle(apiReq);
	}
}
